import { compose } from "@reduxjs/toolkit";
import { connect } from "react-redux";
import PreviewAndLaunchStep from "./PreviewAndLaunchStep.layout";
import { memo } from "react";

const mapStateToProps = (state) => ({
    lastAddedDraftLandingPage: state.landingPages.lastAddedDraftLandingPage,
    isLandingPageFormLoading: state.landingPages.isLandingPageFormLoading,

});

const mapDispatchToProps = (dispatch): any => ({});

const decorate = compose(connect(mapStateToProps, mapDispatchToProps));

export default decorate(memo(PreviewAndLaunchStep));
